<script context="module" lang="ts">
  import { get } from "svelte/store";
  import StagedRolloutStore from "@shared/svelte/Stores/StagedRolloutStore";

  export function stagedRolloutCheck(rolloutName: string): boolean {
    const rollouts: { [key: string]: boolean } = get(StagedRolloutStore);

    return rollouts && rollouts[rolloutName];
  }

</script>
